import { Icon } from 'assets/Icon.js';

import { useNotificationBellEffects } from './NotificationBell.effects.js';
import {
  AnimatedNotificationDot,
  NotificationButton,
  NotificationDot,
  NotificationLabel,
} from './NotificationBell.styles.js';

export const NotificationBell = () => {
  const {
    actionsCount,
    notificationButtonDisabled,
    navigateToActions,
    showAnimation,
  } = useNotificationBellEffects();

  const DotComponent = showAnimation
    ? AnimatedNotificationDot
    : NotificationDot;
  return (
    <NotificationButton
      onClick={navigateToActions}
      disabled={notificationButtonDisabled}
    >
      <Icon
        sx={{
          height: 24,
          rotate: notificationButtonDisabled ? undefined : '45deg',
        }}
        icon="navigationBellSvg"
      />
      {actionsCount > 0 && (
        <DotComponent>
          <NotificationLabel>
            {actionsCount < 100 ? actionsCount : '99'}
          </NotificationLabel>
        </DotComponent>
      )}
    </NotificationButton>
  );
};
